<template>
  <div class="amount-number">
    <span class="integer">{{ symbol }}{{ integerPart }}</span>
    <span v-if="decimalPart" class="decimal">.{{ decimalPart }}</span>
  </div>
</template>

<script>
export default {
  name: 'AmountNumber',
  props: {
    amount: {
      type: Number,
      required: true
    },
    symbol: {
      type: String,
      default: ''
    },
    decimals: {
      type: Number,
      default: 2 // kaç hane ondalık göstereceğiz
    }
  },
  data() {
    return {
      amountInterval: null,
      amountCurrent: 0
    };
  },
  computed: {
    formatted() {
      // animasyonlu current değeri fixed ondalıkla formatla
      return Number(this.amountCurrent).toFixed(this.decimals);
    },
    integerPart() {
      return this.formatted.split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    decimalPart() {
      return this.formatted.split('.')[1];
    }
  },
  watch: {
    amount: {
      handler() {
        clearInterval(this.amountInterval);
        const step = (this.amount - this.amountCurrent) / 60;
        this.amountInterval = setInterval(() => {
          this.amountCurrent += step;
          if (
            (step >= 0 && this.amountCurrent >= this.amount) ||
            (step <= 0 && this.amountCurrent <= this.amount)
          ) {
            clearInterval(this.amountInterval);
            this.amountCurrent = this.amount;
          }
        }, 1000 / 60);
      },
      immediate: true
    }
  },
  mounted() {
    this.amountCurrent = this.amount;
  }
};
</script>

<style scoped>
.amount-number {
  font-family: "Rubik", sans-serif;
   
  display: inline-flex;
  align-items: baseline;
  color: #fff;
}

.amount-number .integer {
  font-size: 14px;
  font-weight: 700;
}

.amount-number .decimal {
  font-size: 10px;  /* 🔥 küçük ondalık */
  font-weight: 500;
  opacity: 0.8;
  margin-left: 1px;
}

@media only screen and (max-width: 1175px) {
  .amount-number .integer {
    font-size: 12px;
  }
  .amount-number .decimal {
    font-size: 9px;
  }
}
</style>
